export default __webpack_public_path__ + "static/media/1.41587292.png";